import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { api } from '../services/AuthService';

const ImageUploadModal = ({ open, onClose, onUpload, title = 'Upload de Imagem', selectedLanchonete }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Selecione uma imagem');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', selectedFile);

      const response = await api.post(`/lanchonetes/${selectedLanchonete?.id}/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const result = response.data;
      
      if (response.status === 200) {
        alert('Logo da lanchonete enviada com sucesso!');
        onUpload(result);
        handleClose();
      } else {
        alert(result.error || 'Falha ao enviar imagem');
      }
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
      alert('Falha ao enviar imagem');
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    setPreview(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{ p: 4, minWidth: 400 }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        
        <Box sx={{ border: '2px dashed #ccc', p: 2, mb: 2, textAlign: 'center' }}>
          {preview ? (
            <img 
              src={preview} 
              alt="Preview" 
              style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 1 }}
            />
          ) : (
            <Box>
              <CloudUploadIcon sx={{ fontSize: 48, color: '#ccc', mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Arraste uma imagem aqui ou clique para selecionar
              </Typography>
            </Box>
          )}
        </Box>

        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
          id="image-upload-input"
        />

        {selectedFile && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" gutterBottom>
              Arquivo selecionado: {selectedFile.name}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CloudUploadIcon />}
              onClick={handleUpload}
              disabled={uploading}
              fullWidth
            >
              {uploading ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Enviando...
                </>
              ) : (
                'Fazer Upload'
              )}
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default ImageUploadModal;
